import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CreditScoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"credit_score"}/>
}
